import { useState } from "react";
import { useRef } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, resolveImg } from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Imagine" }) {
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload-image", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Imagine încărcată");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Eroare la încărcare");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div>
      <p className="text-xs font-semibold text-slate-500 mb-1.5">{label}</p>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative w-20 h-20 rounded-lg overflow-hidden border border-[#E2E8F0] shrink-0">
            <img src={resolveImg(value)} alt="preview" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute top-0.5 right-0.5 w-5 h-5 rounded-full bg-black/60 text-white flex items-center justify-center"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ) : null}
        <button
          type="button"
          onClick={() => ref.current?.click()}
          disabled={loading}
          className="flex items-center gap-2 px-4 h-10 rounded-lg border border-dashed border-[#E2E8F0] text-slate-500 hover:border-[#FF5A1F] hover:text-[#FF5A1F] transition-colors duration-200 text-sm font-medium"
        >
          {loading ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <ImagePlus className="w-4 h-4" />
          )}
          {value ? "Schimbă" : "Încarcă imagine"}
        </button>
        <input
          ref={ref}
          type="file"
          accept=".jpg,.jpeg,.png,.gif,.webp"
          onChange={upload}
          className="hidden"
        />
      </div>
    </div>
  );
}
